import { render, staticRenderFns } from "./SerialsIndex.vue?vue&type=template&id=6662f208&scoped=true"
import script from "./SerialsIndex.vue?vue&type=script&lang=js"
export * from "./SerialsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6662f208",
  null
  
)

export default component.exports